import Vue from 'vue'
import VueRx from 'vue-rx'
import { sync } from 'vuex-router-sync'
import AuthPlugin from '@rhitics/vue-auth-plugin'
import { removeLoadingSVG } from '@rhitics/rhitics/utils'
import SlackPlugin from '@rhitics/vue/slack-plugin'
import MomentPlugin from '@rhitics/vue/moment-plugin'
import CarbonPlugin from './carbon-plugin'
import VueToast from 'vue-toast-notification'
import VueCompositionAPI from '@vue/composition-api'
import 'vue-toast-notification/dist/theme-sugar.css'

Vue.use(VueCompositionAPI)
Vue.use(VueRx)
Vue.use(SlackPlugin)
Vue.use(MomentPlugin)
Vue.use(CarbonPlugin)
Vue.use(AuthPlugin)
Vue.use(VueToast, { position: 'bottom' })

Vue.prototype.$bus = new Vue()

export function createApp(App: Vue.Component, options: any = {}) {
  const _options: any = {
    mounted() {
      removeLoadingSVG()
    },
    render: h => h(App)
  }

  if (options.store && options.router) {
    sync(options.store, options.router)
  }

  return new Vue(Object.assign(_options, options))
}
